// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"873":"0aa6192f","890":"91a64fc6","906":"a9af0e93","970":"df34d60a"}[chunkId] + ".css";
};